import { useState } from "react";
import type { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Search, X } from "lucide-react";

import styles from "../styles/sidebar/SearchBar.module.css";

type SearchBarProps = {
  searchTerm?: string;
  onSearchChange?: Dispatch<SetStateAction<string>>;
};

const SearchBar = ({ searchTerm = "", onSearchChange = () => {} }: SearchBarProps) => {
  const [localSearch, setLocalSearch] = useState<string>(searchTerm);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearch(value);
    onSearchChange(value);
  };

  const clearSearch = () => {
    setLocalSearch("");
    onSearchChange("");
  };

  return (
    <div className={styles.searchBar}>
      <h3 className={styles.searchTitle}>Search Posts</h3>
      <div className={styles.searchInputContainer}>
        <Search className={styles.searchIcon} size={18} />
        <input
          type="text"
          placeholder="Search articles..."
          value={localSearch}
          onChange={handleSearchChange}
          className={styles.searchInput}
        />
        {localSearch && (
          <button
            onClick={clearSearch}
            className={styles.clearButton}
            aria-label="Clear search"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
